import React, { FC, ReactElement, ReactNode } from 'react';
import { BannerProps } from '../Banner';
import { IntroProps } from '../Intro';
import * as styles from './styles';

export interface HeaderProps {
  banner?: ReactElement<BannerProps>;
  intro?: ReactElement<IntroProps>;
  children?: ReactNode;
}

const Header: FC<HeaderProps> = ({ banner, intro, children }) => (
  <header className={styles.header} aria-label="header">
    {banner}
    {intro}
    {children}
  </header>
);

export default Header;
